<raf-error *ngIf="everybodysDeadDave$ | async; else online" [variant]="errorVariant" ></raf-error>

<ng-template #online>
  <router-outlet></router-outlet>
</ng-template>

